
import React from 'react';
import Navbar from '../../../components/Navbar';
import Footer from '../../../components/Footer';
import Copyright from '../../../components/Copyright';
import HyperAutomation from './HyperAutomation';

export default function Blog() {
  return (
    <>
        <Navbar />
        <HyperAutomation />
        <Footer />
        <Copyright />
    </>
  )
}